import { BANNER_DATA } from '@/utils/const/activity/lvs';
import React from 'react';
import SActivityBanner from './style.module.scss';
import { WebPNativeImage, WebPNextImage } from '@/components/WebPImage';
import FadeIn from '@/components/commonComponents/fadeIn';
import { useUserAgentInfo } from '@/context/user-agent';
import { src } from '@/utils/common';

const ActivityBanner = ({ data }: { data: typeof BANNER_DATA }) => {
  const { isMobile } = useUserAgentInfo();
  const {
    prefix,
    title,
    backgroundImage,
    backgroundImageMobile,
    subTitle,
    info,
    partners,
  } = data;
  return (
    <div className={SActivityBanner['banner']}>
      <div className={SActivityBanner['background']}>
        <WebPNextImage
          src={isMobile ? backgroundImageMobile : backgroundImage}
          layout="fill"
        />
      </div>
      <div className={SActivityBanner['content']}>
        <div className={SActivityBanner['logos']}>
          {partners.map((value, index) => (
            <>
              <WebPNativeImage
                src={src(value)}
                className={SActivityBanner['logo']}
                key={value}
              />
              <div className={SActivityBanner['divider']} key={index} />
            </>
          ))}
        </div>
        <FadeIn>
          <div className={SActivityBanner['info']}>
            <div className={SActivityBanner['prefix']}>{prefix}</div>
            <div className={SActivityBanner['title']}>{title}</div>
            <div className={SActivityBanner['sub-title']}>{subTitle}</div>
            <div className={SActivityBanner['meta-info']}>{info}</div>
          </div>
        </FadeIn>
      </div>
    </div>
  );
};

export default ActivityBanner;
